export default "__VITE_ASSET__DIwu4Q3p__"